import { createFileRoute } from '@tanstack/react-router';
import { EntryFlowPage } from '@/features/resume-builder/entry';

/** EU-762 RN-40 — "Edite seu currículo". */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/editar')({
  component: () => <EntryFlowPage mode="edit" />,
});
